import { render, staticRenderFns } from "./detail_novelty_page.vue?vue&type=template&id=10a97fb8&scoped=true"
import script from "./detail_novelty_page.vue?vue&type=script&lang=js"
export * from "./detail_novelty_page.vue?vue&type=script&lang=js"
import style0 from "./detail_novelty_page.vue?vue&type=style&index=0&id=10a97fb8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a97fb8",
  null
  
)

export default component.exports